<template>
  <div class="analysis_warp">
    <div class="top"
         @click="back">
      <img src="@/assets/返回.png"
             class="fixed_back_btn"
              
             alt="">
<div class="title">目标院校&专业</div>
    </div>
<div>
    <div class="content">
      <div>
        <div class="text">目标院校</div>
        <el-input placeholder="请输入你的目标院校"
                  v-model="form.college_name" />

      </div>
      <div class="my-box">
        <div class="text">目标专业</div>
        <el-input placeholder="请输入你的目标专业"
                  @change="handleClick"
                  v-model="form.professional" />

      </div>

    </div>
    <div class="btn"
          >
           <img src="@/assets/二维码.png"
             alt="">
      
  </div>
        
  </div>
  </div>
</template>

  <script>
import { getPaper } from '@/api/quick.js'
import { getUserInfo, getSubmitGoalCollege } from '@/api/subject.js'
import { getVipInfo } from '@/api/vip.js'

export default {
  data () {
    return {

      userId: '',
      form: { college_name: '', professional: '' },


    }
  },
  mounted () {

    this.getInfo()
    this.getviper()
  },
  beforeDestroy () {

  },
  methods: {
    async getviper () {
       const { data } = await getVipInfo()
       if(data.user_version==0){
          this.$router.push('/goal3')
       }
    
    },

    toPage1 () {
      this.$router.push('/goal2')
    },
    async getInfo () {

      const { data } = await getUserInfo()
      this.form.college_name = data.college_name
      this.form.professional = data.professional
    },

    back () {
      this.$router.push('/index')
    },
    async handleClick () {
      const data = {
        ...this.form
      }
      const { status } = await getSubmitGoalCollege(data)
      if (status === 200) {
        this.$message.success('设置成功')
        this.form = {
          college_name: '',
          professional: '',
        }

      }
    },
    async submit () {
      const { status } = await addPost(this.$refs.FormRef.form1)
      if (status === 200) {
        this.$message.success('发帖成功')
        this.cancel()
      }
    },
    cancel () {
      // 关闭弹窗逻辑，根据你项目实现
      this.showWindow = false
    }
  }
}
</script>
 
<style lang="scss" scoped>
::v-deep .el-input {
  display: flex;
  width: 675rem;
  height: 59rem;
  padding: 0 16rem;
  align-items: center;
  gap: 8rem;
  border-radius: 8rem;
  background: #f4f7ff;
}
::v-deep .el-input__inner {
  font-size: 24rem !important;
  border: none;
  background-color: transparent;
  background-image: none;

  font-size: inherit;
}
.my-box {
  margin-left: 233rem;
}

@media (max-width: 1815px) {
  .my-box {
    margin-left: 230rem;
  }
}

@media (max-width: 1662px) {
  .my-box {
    margin-left: 263rem;
  }
}
@media (max-width: 1635px) {
  .my-box {
    margin-left: 330rem;
  }
}
@media (max-width: 1390px) {
  .my-box {
    margin-left: calc(380rem + (1390px - 100vw) * 0.02);
  }
}
.analysis_warp {
  // width: 100vw;  
  height: calc(100vh - -135rem);
  overflow: hidden;
 background: linear-gradient(359deg, #FFF 6.55%, #C8E4FC 52.03%, #DBEAFF 99.3%);
  .top {
    margin-top: 56rem;
    margin-left: 40rem;
    // width: 48rem;
    height: 48rem;
    display: flex;
    align-items: center;
    .title{
      color: #040C55;
text-align: center;
font-family: "PingFang SC";
font-size: 28rem;
margin-left: 40%;
font-style: normal;
font-weight: 600;
line-height: 42px; /* 150% */
    }
    img {
      width: 48rem;
      height: 48rem;
    }
  }
  .middle {
    img {
      width: 14rem;
      height: 14rem;
    }
    display: flex;
    width: 1200rem;
    margin-left: 360rem;
    height: 40rem;
    flex-shrink: 0;
    border-radius: 5rem;
    background: var(--Brand-Color_1, #e3f2fd);
    color: #000;
    text-align: center;
    align-items: center;
    font-size: 16rem;
    font-style: normal;
    font-weight: 400;
    line-height: 24rem; /* 150% */
    margin-top: 32rem;
    margin-bottom: 32rem;
  }
  .content_bottom {
    display: flex;
    width: 1200rem;
    height: 56rem;
    padding: 8rem 28rem;
    justify-content: center;
    align-items: center;
    gap: 6rem;
    cursor: pointer;
    border-radius: var(--Radius-XS, 8rem);
    background: var(--Brand-Color_6default, #2196f3);
    color: var(--light-ffffff, #fff);
    text-align: center;
    margin-left: 17.5%;
    font-size: 24rem;
    margin-top: 36rem;
    font-style: normal;
    font-weight: 400;
    line-height: 36rem; /* 150% */
  }
  .content {
    margin-left: 40rem;
    // gap: 200rem;
    display: flex;
    margin-top: 5vh;
    .text {
      color: #040c55;
      margin-bottom: 16rem;
      font-size: 20rem;
      font-style: normal;
      font-weight: 600;
      line-height: 30px; /* 150% */
    }
  }
  .btn {
    // margin-top: 15vh;
    // margin-left: 106vh;
    // background: beige;
    display: flex;
   
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 10px;
  }
}
.fixed_btn {
  position: fixed;
  top: 50rem;
  right: 30rem;
  font-size: 24rem;
  display: flex;
  // width: 350rem;
  div {
    // flex: 1;
    text-align: center;
  }
  img {
    width: 36rem;
    height: 36rem;
    margin-left: 30rem;
  }
}
</style>